module.exports = __webpack_public_path__ + "img/solve_pic02.457a23e4.jpg";